import React from "react";
import { RoomUpgrade } from "models/RoomUpgrade";
import { Food } from "models/Food";
import { Facilities } from "models/Facilities";
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent,  Typography, CardMedia, IconButton, Modal, useTheme} from '@material-ui/core';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import { CounterButton } from "components/CounterButton";
import { GridContainer } from "components/GridContainer";
import { GridItem } from "components/GridItem";

type CardType = RoomUpgrade | Food | Facilities;

interface IProps {
    productCard: CardType;
    onSelectCard?: (selectedCard: CardType) => void;
    selectedCard?: boolean;
    counterButtonOn: boolean;
    onTotalPriceChange?: (price: number) => void;
    onTotalCountChange?: (count: number) => void;
  }
  
const useStyles = makeStyles({
  root: {
    display: 'flex',
    margin: '10px',
    position: 'relative',
  },
  media: {
    width: '100%',
    height: 'auto',    
    position: 'relative',
    objectPosition: 'center'
  },
  content: {
    height: 'auto',
    objectFit: 'cover',
    display: 'flex',
    flexDirection: 'row',
  },
  productPrice:{
    display: 'flex',
    justifyContent: 'flex-end',
  },  
  fullscreenIcon: {
    position: 'absolute',
    top: '10px',
    left: '10px',
    zIndex: 1,
    color: 'white', 
    transform: 'translate(-50%, -50%)',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '20px',
    maxWidth: '80%',
    maxHeight: '80%',
    overflow: 'auto',
  },
});

export const ProductCard: React.FC<IProps> = ({ productCard, onSelectCard=()=>{}, selectedCard=false, counterButtonOn, onTotalPriceChange=()=>{}, onTotalCountChange=()=>{}}) => {

    const [isImageOpen, setIsImageOpen] = React.useState(false);
    const [productCount, setProductCount] = React.useState(0);
    const handleCardClick = () => {
      onSelectCard(productCard);
    };
  
    const handleImageClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent> | React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.stopPropagation();
      setIsImageOpen(true);
    };

    const handleModalClose = () => {
      setIsImageOpen(false);
    };

    const handleCountChange = (newCount:number) => {
      setProductCount(newCount);
    };

    function isFood(item: RoomUpgrade | Food): item is Food {
      return (item as Food).quantity !== undefined;
    }
    
    function isFacilities(item: RoomUpgrade | Food | Facilities): item is Facilities {
      return (item as Facilities).hourBooking !== undefined;
    }
    
    React.useEffect(()=>{
      if(isFood(productCard)){
        productCard.quantity = productCount;
      };
      
      let price = productCount * productCard.price;
      onTotalPriceChange(price);
      onTotalCountChange(productCount);
    },[productCount]);

    const classes = useStyles();
    const theme = useTheme();
    return (
      <Card className={classes.root} style={{ backgroundColor: selectedCard ? theme.palette.primary.main : 'white' , color:selectedCard ? 'white' : 'black', position:'relative' }} onClick={handleCardClick}>
        <GridContainer>
            <GridItem xs={12} sm={3}>
              <CardMedia>
                <img
                  className={classes.media}
                  src={productCard.image}
                  alt="Product Image"
                  style={{ width: '100%', height: '200px' }}>            
                </img>
                <IconButton className={classes.fullscreenIcon} onClick={handleImageClick}>
                  <AspectRatioIcon color='secondary'/>
                </IconButton>
              </CardMedia>
            </GridItem>
          
            {counterButtonOn ? (
              <GridItem xs={12} sm={9} className={classes.content} >
                <GridItem xs={12} sm={9} >
                  <CardContent>                  
                      <Typography variant="h6">{productCard.name} </Typography>
                      <Typography variant="body2">{productCard.details}</Typography>                    
                  </CardContent>   
                </GridItem>
                <GridItem xs={12} sm={3}>                
                  <CardContent >
                    <div style={{ position: 'absolute', right: 5}}>
                      <CounterButton onCountChange={handleCountChange}/>  
                    </div>
                    {productCard.price != 0 ? 
                      (                     
                        <Typography style={{ position: 'absolute', bottom: 0, right: 0, margin: 10}} variant="h6" > SGD {productCard.price.toFixed(2)} {isFacilities(productCard) ? '/hour': ''} </Typography>                                      
                      ):
                      null
                    }
                  </CardContent>
                </GridItem>
              </GridItem>             
             ) : (
              <GridItem xs={12} sm={9} className={classes.content}  >                
                <GridItem xs={12} sm={9} >
                  <CardContent>                  
                      <Typography variant="h6">{productCard.name} </Typography>
                      <Typography variant="body2">{productCard.details}</Typography>                    
                  </CardContent>   
                </GridItem>

                <GridItem xs={12} sm={3} >            
                  <CardContent >   
                  {productCard.price != 0 ? 
                    (
                      <Typography style={{ position: 'absolute', bottom: 0, right: 0, margin: 10}} variant="h6"> 
                       SGD {productCard.price.toFixed(2)} {isFacilities(productCard) ? '/hour': ''}                     
                    </Typography>                  
                    ):
                    null
                  }
                  </CardContent>
                </GridItem>
              </GridItem>
              ) 
            }
        </GridContainer>
        <Modal
          open={isImageOpen}
          onClose={handleModalClose}
          className={classes.modal}
        >
          <div className={classes.modalContent}>
            <img
              src={productCard.image}
              alt="Product Image"
              style={{ width: '100%', height: 'auto' }}
            />
          </div>
        </Modal>
      </Card>
    );
  };

  